import React from 'react';
import { motion } from 'framer-motion';
import { Salad, Quote, Star, MapPin, BadgeCheck } from 'lucide-react';
const testimonials = [{
  in: 'PA',
  n: 'Paula A.',
  l: 'Tucumán',
  t: 'Configuré Hotmart en una tarde y recibí mi primer pago automático mientras estaba en consulta. Nunca había cobrado sin estar presente.',
  tag: 'Protocolo 24/7 · Cobro Automático'
}, {
  in: 'VL',
  n: 'Valentín L.',
  l: 'Rosario',
  t: 'El prompt clínico para SOP generó un plan que mi paciente describió como el mejor que había recibido en 3 años de tratamiento.',
  tag: 'Tomo 2 · Prompts Clínicos'
}, {
  in: 'DM',
  n: 'Daniela M.',
  l: 'Córdoba',
  t: 'Usé el script de objeciones la primera vez que alguien me dijo "está caro" y cerré la venta en el siguiente mensaje.',
  tag: 'Protocolo 24/7 · Scripts de Cierre'
}, {
  in: 'SC',
  n: 'Santiago C.',
  l: 'Buenos Aires',
  t: 'Las Plantillas Pro cambiaron la percepción de mis clientes. Por primera vez sienten que reciben un producto de alto valor real.',
  tag: 'Bono 3 · Plantillas Pro'
}];
export function MoreTestimonials() {
  return <section className="py-16 bg-graphite border-y border-petroleum relative overflow-hidden" data-id="element-373">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-electric/5 blur-[120px] rounded-full pointer-events-none" data-id="element-374"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-375">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto mb-14 relative" data-id="element-376">
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-energy to-electric rounded-3xl blur-xl opacity-30 animate-pulse" data-id="element-377"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20" data-id="element-378">
            {/* Decorative salad flourish in background */}
            <div className="absolute -top-16 -right-16 opacity-10 pointer-events-none rotate-12" data-id="element-379">
              <Salad className="w-48 h-48 text-electric" data-id="element-380" />
            </div>
            <div className="absolute -bottom-16 -left-16 opacity-10 pointer-events-none -rotate-12" data-id="element-381">
              <Salad className="w-48 h-48 text-electric" data-id="element-382" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-383"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-384"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-385"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-386"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-387"></div>

            <div className="relative z-10" data-id="element-388">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-389">
                <Salad className="w-3.5 h-3.5" data-id="element-390" />
                Historias reales
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-391">
                <span className="text-white" data-id="element-392">Más profesionales que </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-393">
                  ya lo tienen
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-394"></div>

              {/* Aggregate trust row */}
              <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-textsecondary" data-id="element-395">
                <div className="flex items-center gap-1.5" data-id="element-396">
                  <div className="flex" data-id="element-397">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" data-id="element-398" />)}
                  </div>
                  <span className="text-white font-bold" data-id="element-399">4.9/5</span>
                  <span data-id="element-400">· +1.200 lectores</span>
                </div>
                <span className="hidden md:inline w-1 h-1 rounded-full bg-textsecondary/40" data-id="element-401"></span>
                <div className="flex items-center gap-1.5" data-id="element-402">
                  <BadgeCheck className="w-3.5 h-3.5 text-electric" data-id="element-403" />
                  <span data-id="element-404">Compras verificadas</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-405">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group relative bg-gradient-to-br from-petroleum to-graphite border border-white/10 rounded-2xl p-6 hover:border-electric/40 hover:shadow-[0_0_30px_rgba(125,255,47,0.15)] transition-all duration-300" data-id="element-406">
              {/* Decorative quote mark */}
              <Quote className="absolute top-5 right-5 w-8 h-8 text-electric/15 group-hover:text-electric/30 transition-colors" strokeWidth={2.5} data-id="element-407" />

              {/* Header: avatar + name + location */}
              <div className="flex items-center gap-3 mb-4" data-id="element-408">
                <div className="relative" data-id="element-409">
                  <div className="w-11 h-11 rounded-full bg-gradient-to-br from-electric to-energy text-graphite flex items-center justify-center font-extrabold text-sm shadow-lg shadow-electric/30" data-id="element-410">
                    {t.in}
                  </div>
                  <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-graphite flex items-center justify-center" data-id="element-411">
                    <BadgeCheck className="w-4 h-4 text-electric" strokeWidth={2.5} data-id="element-412" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-413">
                  <div className="text-sm font-bold text-white flex items-center gap-1.5" data-id="element-414">
                    {t.n}
                  </div>
                  <div className="text-xs text-textsecondary flex items-center gap-1" data-id="element-415">
                    <MapPin className="w-3 h-3" data-id="element-416" />
                    {t.l}
                  </div>
                </div>
                {/* Rating */}
                <div className="flex gap-0.5" data-id="element-417">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="w-3 h-3 text-gold fill-gold" data-id="element-418" />)}
                </div>
              </div>

              {/* Quote */}
              <p className="text-sm text-textsecondary leading-relaxed mb-4 relative z-10" data-id="element-419">
                "{t.t}"
              </p>

              {/* Tag */}
              <div className="pt-3 border-t border-white/5" data-id="element-420">
                <span className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider text-electric bg-electric/10 px-2.5 py-1 rounded-full" data-id="element-421">
                  <span className="w-1 h-1 rounded-full bg-electric" data-id="element-422"></span>
                  {t.tag}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}